import { WIDGET_VIEW_COORDINATES } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CoordinatesViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_COORDINATES,
  configuration: () => import("./configuration").then((m) => m.GoogleMapsV2WidgetConfiguration),
  component: () => import("./coordinates-view-widget.component").then((m) => m.CoordinatesViewWidgetComponent)
};
